<template>
  <div class="layout">
    <Layout>
      <AdminHeader />
      <Layout>
        <Sider hide-trigger :style="{background: '#fff'}">
          <AdminLeftMenu />
          <div class="slider-sep"></div>
        </Sider>
        <Layout class="admin-right-wrap">
          <AdminContentBread />
          <!--页面内容主体开始-->
          <Content class="admin-wrap">
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">新闻标题：</Col>
              <Col class="admin-content" span="22">{{newsContent.title}}</Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">所属机构：</Col>
              <Col class="admin-content" span="22">{{newsContent.assoName}}</Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">新闻作者：</Col>
              <Col class="admin-content" span="22">{{newsContent.author}}</Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">所属栏目：</Col>
              <Col class="admin-content" span="22">{{newsContent.columnName}}</Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">内容来源：</Col>
              <Col class="admin-content" span="22">{{newsContent.comeFrom}}</Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">最近提交：</Col>
              <Col class="admin-content" span="22">{{newsContent.lastPost}}</Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">内容摘要：</Col>
              <Col class="admin-content" span="22" v-html="newsContent.description"></Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">新闻封面：</Col>
              <Col class="admin-content" span="22"><img class="admin-news-cover" :src="newsContent.cover"></Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">新闻内容：</Col>
              <Col class="admin-content" span="22" v-html="newsContent.body"></Col>
            </Row>
            <Row class="admin-item" v-if="newsContent.video!=null && newsContent.video!=''">
              <Col class="admin-prefix" span="2">新闻视频：</Col>
              <Col class="admin-content admin-check-video" span="22" v-html="newsContent.video" ></Col>
            </Row>
            <Row class="admin-item">
              <Col class="admin-prefix" span="2">审核操作：</Col>
              <Col class="admin-content" span="22">
                <Button type="success" @click="newsCheckOpt(1)" style="margin-right: 10px;">审核通过</Button>
                <Button type="warning" @click="newsCheckOpt(-1)">审核不通过</Button>
              </Col>
            </Row>
          </Content>
          <!--页面内容主体结束-->
        </Layout>
      </Layout>
    </Layout>
  </div>
</template>
<script>
//图片长宽比例 8 5
import axios from "axios"
import AdminLeftMenu from '@/components/AdminLeftMenu.vue'
import AdminContentBread from '@/components/AdminContentBread.vue'
import AdminHeader from '@/components/AdminHeader.vue'
import nopic from '@/assets/images/nopic.jpg'
export default {
  components: {
    AdminLeftMenu,
    AdminContentBread,
    AdminHeader,
  },

  data () {
    return {
      coverPic: nopic,
      token: '',
      newsContent: {}
    }
  },

  //页面加载完成后执行
  //页面加载完成
  mounted: function() {
    //初始化用户信息
    this.initAuthData()

    //获取学生信息
    this.getNewsContent()
  },

  //页面方法
  methods: {
    //初始化页面基础信息
    initAuthData() {
      let admin = JSON.parse(localStorage.getItem("adminInfo"));
      if(admin!=null) {
        this.token = admin.token
      }
    },

    //从服务端获取文字列表
    getNewsContent() {
      let vm = this
      //console.log(vm.$route.query)
      let id = parseInt(vm.$route.query.id)
      axios.post(
        vm.GLOBAL_API.apiUrl + "/manage/news/get-for-edit",
        {id: id, status: 1},
        {
          headers: {
            'content-type': 'application/json',
            "Authorization": "Bearer " + vm.token
          }
        }
      ).then(function(res) {
        let info = res.data
        //console.log(info)
        vm.newsContent = info.data
        //console.log(vm.newsContent)
      }).catch(function(error) {
        console.log(error)
      });
    },

    //审核操作
    newsCheckOpt(status) {
      status = parseInt(status)
      if(!isNaN(status) && (status==1 || status==-1)) {
        let vm = this
        axios.post(
          vm.GLOBAL_API.apiUrl + "/manage/news/save-for-check",
          {id: vm.newsContent.newsId, status: status},
          {
            headers: {
              'content-type': 'application/json',
              "Authorization": "Bearer " + vm.token
            }
          }
        ).then(function(res) {
          let info = res.data
          let error = parseInt(info.code)
          if(error==0) {
            vm.$Message.success({
                content: info.message,
                duration: 3,
                closable: true,
                onClose:function() {
                  window.close()
                }
            });
          } else {
            vm.$Message.error(info.message);
          }
          
        }).catch(function(error) {
          console.log(error)
        });
      }
    }

  }
}
</script>